import { render, staticRenderFns } from "./GeneralReportsTable.vue?vue&type=template&id=245821d3&scoped=true"
import script from "./GeneralReportsTable.vue?vue&type=script&lang=js"
export * from "./GeneralReportsTable.vue?vue&type=script&lang=js"
import style0 from "./GeneralReportsTable.vue?vue&type=style&index=0&id=245821d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245821d3",
  null
  
)

export default component.exports